import { forwardRef } from 'react'

import { tv, type VariantProps } from 'tailwind-variants'

export const gridVariants = tv({
  base: 'grid',
  variants: {
    cols: {
      1: 'grid-cols-1',
      2: 'grid-cols-2',
      3: 'grid-cols-3',
      4: 'grid-cols-4',
      6: 'grid-cols-6',
      12: 'grid-cols-12'
    },
    rows: {
      1: 'grid-rows-1',
      2: 'grid-rows-2',
      3: 'grid-rows-3',
      4: 'grid-rows-4',
      6: 'grid-rows-6'
    },
    gap: {
      0: 'gap-0',
      1: 'gap-1',
      2: 'gap-2',
      4: 'gap-4',
      6: 'gap-6',
      8: 'gap-8'
    },
    flow: {
      row: 'grid-flow-row',
      col: 'grid-flow-col',
      dense: 'grid-flow-dense',
      rowDense: 'grid-flow-row-dense',
      colDense: 'grid-flow-col-dense'
    },
    align: {
      start: 'items-start',
      center: 'items-center',
      end: 'items-end',
      stretch: 'items-stretch'
    },
    justify: {
      start: 'justify-start',
      center: 'justify-center',
      end: 'justify-end',
      between: 'justify-between',
      around: 'justify-around',
      evenly: 'justify-evenly'
    }
  },
  defaultVariants: {
    cols: 2,
    gap: 2,
    flow: 'row',
    align: 'stretch',
    justify: 'start'
  }
})

export type TGridProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof gridVariants>

export const Grid = forwardRef<HTMLDivElement, TGridProps>(
  ({ className, cols, rows, gap, flow, align, justify, ...props }, ref) => (
    <div
      ref={ref}
      className={gridVariants({
        cols,
        rows,
        gap,
        flow,
        align,
        justify,
        className
      })}
      {...props}
    />
  )
)

Grid.displayName = 'Grid'
